import React from "react";
import Button from '../components/Button';

export default function Ejercicios() {

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">ACTIVIDAD / EJERCICIO FÍSICO</h3>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">La práctica de actividad física  y ejercicio físico  es una conducta promotora de salud, lo que ayudará a mejorar el estado de salud de la población y a revertir la pérdida de masa muscular y movilidad.</p>

        <p className="mb-2">Se debe realizar actividad aeróbica siempre que su estado de salud lo permita.</p>

        <p className="mb-2">Se recomienda 30 minutos al día durante 5 días o 150 minutos a la semana de intensidad moderada y la mitad si es vigoroso.</p>

        <p className="mb-2">La cantidad de pasos necesarios para conseguir beneficios cardiovasculares son 7.000 pasos/día.</p>

        <p className="mb-2">Se recomienda ejercicios de fuerza mínimo 2 días/semana.</p>

        <p className="mb-2">No se debe olvidar recomendar estar bien hidratado/a con la textura pautada y descansar cuantas veces le haga falta.</p>

        <p>A continuación, se presentan diferentes ejercicios que puede realizar. Seleccione aquellos ejercicios que desea pautar.</p>
      </div>

      {/* Ejercicios descargables */}

      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <a
          href="/docs/ejercicio-01_caminar-en-llano-y-desnivel.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 01: Caminar (en llano y desnivel)</Button>
        </a>

        <a
          href="/docs/ejercicio-02_sentadilla.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 02: Sentadilla</Button>
        </a>

        <a
          href="/docs/ejercicio-03_extension-de-piernas.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 03: Extensión de piernas</Button>
        </a>

        <a
          href="/docs/ejercicio-04_inclinaciones-laterales.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 04: Inclinaciones laterales</Button>
        </a>

        <a
          href="/docs/ejercicio-05_cerrar-codos.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 05: Cerrar codos</Button>
        </a>

        <a
          href="/docs/ejercicio-06_flexion-de-brazos.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 06: Flexión de brazos</Button>
        </a>

        <a
          href="/docs/ejercicio-07_fuerza-de-prension-manual.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 07: Fuerza de prensión manual</Button>
        </a>

        <a
          href="/docs/ejercicio-08_extension-de-rodillas-en-sedestacion.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 08: Extensión de rodillas en sedestación</Button>
        </a>

        <a
          href="/docs/ejercicio-09_extension-de-piernas.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 09: Extensión de piernas</Button>
        </a>

        <a
          href="/docs/ejercicio-10_flexion-de-pared.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 10: Flexión de pared</Button>
        </a>

        <a
          href="/docs/ejercicio-11_elevacion-lateral-de-los-brazos.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 11: Elevación lateral de los brazos</Button>
        </a>

        <a
          href="/docs/ejercicio-12_extension-de-brazos.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 12: Extensión de brazos</Button>
        </a>

        <a
          href="/docs/ejercicio-13_escurrir-toalla.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 13: Escurrir toalla</Button>
        </a>

        <a
          href="/docs/ejercicio-14_inclinaciones-laterales.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio 14: Inclinaciones laterales</Button>
        </a>
      </div>
    </div>
  );
}